import React, { useState } from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import ConfirmationModal from './ConfirmationModal';
import { InlineSpinner } from './LoadingState';
import { swapErrorMessage, swapSuccessMessage } from '../common/speakerSwap';

// Swaps who is labelled Agent and Customer on a call whose recorder put them on
// the opposite channels, then (server-side) re-runs the evaluation, because the
// LLM scored the call with the roles reversed.
const SwapSpeakersButton = ({ onSwap, setAlert, template, className = '' }) => {
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);

  const rescoreText = template
    ? `then re-scores the call with template "${template}"`
    : 'then regenerates the call summary';

  const handleConfirm = async () => {
    setConfirming(false);
    setLoading(true);
    try {
      const result = await onSwap();
      setAlert?.({ variant: 'success', heading: 'Speakers swapped', text: swapSuccessMessage(result) });
    } catch (err) {
      setAlert?.({ variant: 'error', heading: 'Swap failed', text: swapErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setConfirming(true)}
        disabled={loading}
        className={`btn-outline disabled:opacity-50 ${className}`}
        aria-busy={loading}
      >
        {loading ? <InlineSpinner light className="mr-2" /> : <FaExchangeAlt className="w-4 h-4 mr-2" />}
        {loading ? 'Swapping...' : 'Swap Agent / Customer'}
      </button>

      <ConfirmationModal
        open={confirming}
        title="Swap Agent and Customer?"
        message={`This swaps who is labelled Agent and Customer on this call, ${rescoreText}. Any manual score overrides on this call will be replaced.`}
        confirmText="Swap and re-score"
        onClose={() => setConfirming(false)}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default SwapSpeakersButton;
